/*!
 * Copyright (c) 2021-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { Remediator } from './Base/Remediator';
import { getAuthenticatorFromRemediation } from './util';
export class SelectEnrollmentChannel extends Remediator {
    canRemediate() {
        return Boolean(this.values.channel);
    }
    getNextStep(context) {
        const common = super.getNextStep();
        const options = this.getChannels();
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign(Object.assign({}, common), (options && { options })), { authenticator });
    }
    getChannels() {
        var _a;
        const authenticator = getAuthenticatorFromRemediation(this.remediation);
        const remediationValue = authenticator.value;
        return (_a = remediationValue.form.value.find(({ name }) => name === 'channel')) === null || _a === void 0 ? void 0 : _a.options;
    }
    getData() {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: this.values.channel,
            },
            stateHandle: this.values.stateHandle,
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'channel');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
SelectEnrollmentChannel.remediationName = 'select-enrollment-channel';
